export default __webpack_public_path__ + "static/media/flamingo.b78b6f46.svg";